import React from "react";
import { skills } from "../data";
import {} from "@heroicons/react/solid";
import { Fade } from "react-reveal";
import Git from "../assets/SVG/github.svg";
import Facebook from "../assets/SVG/facebook.svg";
import Twitter from "../assets/SVG/twitter.svg";
import Linkedin from "../assets/SVG/linkedin.svg";
const Footer = () => {
  return (
    <section id="footer">
      <div className=" mt-80 bg-gray-800  ">
        {/* <Fade bottom delay="100">
          <div className="text-center font-7xl h-40">
            &lt;/&gt; with ❤ by John Deo
          </div>
        </Fade> */}
        <h1 className="text-center py-4 text-2xl text-white">Connect with Me</h1>
        <div className="flex justify-center	 ">
          <a href="https://github.com/Slowgeek">
            <img className="px-8" alt="github" src={Git} />
          </a>
          <a href="https://www.linkedin.com/in/ritesh-kumar-300a221b7/">
            {" "}
            <img className="px-8" alt="github" src={Linkedin} />
          </a>
          <a href="#">
            {" "}
            <img className="px-8" alt="github" src={Facebook} />
          </a>
          <a href="https://twitter.com/R_i_t_esh">
            {" "}
            <img className="px-8" alt="github" src={Twitter} />
          </a>
        </div>
        <h1 className="text-center py-4 text-2xl text-white">
          {" "}
          &lt;/&gt; with ❤ by Ritesh
        </h1>
      </div>
    </section>
  );
};

export default Footer;
